module.exports = __webpack_public_path__ + "static/img/Account-small.9ea32b69.png";